import { useCallback } from 'react';

import { getGetAuthApiLoginStatusQueryKey } from 'shared/hooks/auth-api/login';
import { getGetSettingsQueryKey } from 'shared/hooks/payment-api/settings-endpoint';
import { getGetAccessibleAccountsQueryKey } from 'shared/hooks/payment-api/accessible-accounts-endpoint';
import { queryClient } from 'shared/utils/quryClient';

export const useInvalidateObserverQueries = () => {
  return useCallback(() => {
    queryClient.invalidateQueries({
      predicate: ({ queryKey }) => {
        const excludedKeys = [
          ...getGetSettingsQueryKey(),
          ...getGetAuthApiLoginStatusQueryKey(),
          ...getGetAccessibleAccountsQueryKey()
        ];

        return !excludedKeys.some(key => queryKey.includes(key));
      }
    });
  }, []);
};
